module.exports = __webpack_public_path__ + "static/media/location-icon-atlas.37932833.png";